module.exports = __webpack_public_path__ + "assets/img/20-m.1332cb7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/20-m.jpg
// module id = XBNR
// module chunks = 0